console.log("Shopping Assistant V2 Loaded");

const AI_INTENTS = {

    SEARCH: "search",

    FEATURES: "features",

    WARRANTY: "warranty",

    DETAILS: "details",

    RECOMMENDATION: "recommendation",

    COMPARISON: "comparison",

    UNKNOWN: "unknown"

};

function detectIntent(message){

    message = message.toLowerCase();

    // Features

    if(
        message.includes("feature") ||
        message.includes("specification") ||
        message.includes("specifications") ||
        message.includes("functions")
    ){

        return AI_INTENTS.FEATURES;

    }

    // Warranty

    if(
        message.includes("warranty") ||
        message.includes("guarantee")
    ){

        return AI_INTENTS.WARRANTY;

    }

    // Comparison

    if(
        message.includes("compare") ||
        message.includes("difference")
    ){

        return AI_INTENTS.COMPARISON;

    }

    // Recommendation

    if(

        message.includes("for my shop") ||

        message.includes("for shop") ||

        message.includes("for office") ||

        message.includes("for warehouse") ||

        message.includes("for home") ||

        message.includes("recommend")

    ){

        return AI_INTENTS.RECOMMENDATION;

    }

    // Product Details

    if(

        message.includes("tell me about") ||

        message.includes("about")

    ){

        return AI_INTENTS.DETAILS;

    }

    return AI_INTENTS.SEARCH;

}

function testAI(message){

    const intent = detectIntent(message);

    const product = detectProduct(message);

    console.log("MESSAGE :", message);

    console.log("INTENT :", intent);

    console.log("PRODUCT :", product);

    if(product){

        console.log(
            generateProductResponse(product)
        );

    }

}

const PRODUCT_KEYWORDS = {

    "bulb camera": "IFI Bulb Camera",

    "indoor camera": "Indoor Camera",

    "outdoor camera": "Outdoor Camera",

    "fingerprint lock": "Fingerprint Lock",

    "smart lock": "Fingerprint Lock",

    "gps tracker": "GPS Tracker",

    "smart watch": "Smart Watch",

    "video doorbell": "Video Doorbell",

    "dash camera": "Dash Camera",

    "hidden camera": "Hidden Camera"

};

// function detectProduct(message){

//     message = message.toLowerCase();

//     for(const keyword in PRODUCT_KEYWORDS){

//         if(message.includes(keyword)){

//             return PRODUCT_KEYWORDS[keyword];

//         }

//     }

//     return null;

// }

let ALL_PRODUCTS = [];

async function loadProducts() {

    try {

        console.log("Loading Shopify Products...");

        const response = await fetch(
            "/collections/all/products.json?limit=250"
        );

        const data = await response.json();

        ALL_PRODUCTS = data.products;

        console.log(
            "Products Loaded:",
            ALL_PRODUCTS.length
        );

    }

    catch(error){

        console.error(
            "Unable to load products",
            error
        );

    }

}

document.addEventListener("DOMContentLoaded", function(){

    loadProducts();

});

function detectProduct(message){

    message = message.toLowerCase();

    let bestMatch = null;

    let highestScore = 0;

    ALL_PRODUCTS.forEach(product=>{

        const title =
        product.title.toLowerCase();

        let score = 0;

        title.split(" ").forEach(word=>{

            if(
                word.length > 2 &&
                message.includes(word)
            ){

                score++;

            }

        });

        if(score > highestScore){

            highestScore = score;

            bestMatch = product;

        }

    });

    return bestMatch;

}


const PRODUCT_PHRASES = {

    "bulb camera": [
        "bulb camera"
    ],

    "fingerprint lock": [
        "fingerprint",
        "padlock",
        "biometric",
        "smart lock"
    ],

    "gps tracker": [
        "gps tracker",
        "vehicle tracker",
        "car tracker"
    ],

    "doorbell": [
        "video doorbell",
        "doorbell"
    ],

    "smart watch": [
        "smart watch",
        "smartwatch"
    ],

    "voice recorder": [
        "voice recorder",
        "audio recorder"
    ],

    "hidden camera": [
        "hidden camera",
        "spy camera",
        "mini camera"
    ],

    "dash camera": [
        "dash camera",
        "dashcam"
    ],

    "smart bulb": [
        "smart bulb",
        "wifi bulb"
    ],

    "smart switch": [
        "smart switch",
        "wifi switch"
    ],

    "smart sensor": [
        "motion sensor",
        "gas sensor",
        "smoke sensor",
        "door sensor",
        "water sensor"
    ],

    "smart washroom": [
        "automatic tap",
        "sensor tap",
        "touchless tap",
        "smart faucet",
        "toilet seat"
    ],

    "outdoor camera": [
        "outdoor camera"
    ],

    "indoor camera": [
        "indoor camera"
    ]

};


function findMatchingProducts(message, category = null) {

    message = message.toLowerCase().trim();

    const matches = [];

    // Detect category phrase (Bulb Camera, Fingerprint Lock, etc.)
    let detectedPhrase = null;

    for (const phrase in PRODUCT_PHRASES) {

        if (message.includes(phrase)) {

            detectedPhrase = phrase;

            break;

        }

    }

    ALL_PRODUCTS.forEach(product => {

        const title = product.title.toLowerCase();

        const tags = Array.isArray(product.tags)
            ? product.tags.join(" ").toLowerCase()
            : (product.tags || "").toLowerCase();

        const type = (product.product_type || "").toLowerCase();

        const text = title + " " + tags + " " + type;

        //----------------------------------------
        // CATEGORY FILTER
        //----------------------------------------

        if (category) {

            const keywords = PRODUCT_FILTERS[category];

            if (keywords) {

                const matched = keywords.some(keyword =>
                    text.includes(keyword.toLowerCase())
                );

                if (!matched) {
                    return;
                }

            }

        }

        let score = 0;

        //----------------------------------------
        // PRODUCT PHRASE MATCH
        //----------------------------------------

        if (detectedPhrase) {

            PRODUCT_PHRASES[detectedPhrase].forEach(keyword => {

                if (title.includes(keyword))
                    score += 100;

                if (tags.includes(keyword))
                    score += 80;

            });

        }

        //----------------------------------------
        // NORMAL SEARCH
        //----------------------------------------

        else {

            if (title.includes(message))
                score += 100;

            if (tags.includes(message))
                score += 80;

            message.split(" ").forEach(word => {

                if (word.length < 3)
                    return;

                if (title.includes(word))
                    score += 10;

                if (tags.includes(word))
                    score += 8;

            });

        }

        //----------------------------------------
        // BONUS FOR REQUIREMENT
        //----------------------------------------

        const requirement = getPrimaryRequirement(message);

        if (requirement === "home") {

            if (text.includes("indoor"))
                score += 20;

            if (text.includes("bulb"))
                score += 15;

        }

        if (requirement === "shop") {

            if (text.includes("outdoor"))
                score += 20;

            if (text.includes("ptz"))
                score += 15;

        }

        if (requirement === "office") {

            if (text.includes("fingerprint"))
                score += 20;

        }

        if (requirement === "garden") {

            if (text.includes("outdoor"))
                score += 20;

            if (text.includes("solar"))
                score += 15;

        }

        if (score > 0) {

            matches.push({
                product,
                score
            });

        }

    });

    matches.sort((a, b) => b.score - a.score);

    return matches;

}


function generateProductResponse(product){

    if(!product){

        return "Sorry, I couldn't find that product.";

    }

    const price =
        product.variants &&
        product.variants.length
        ? product.variants[0].price
        : "N/A";

    return `
${product.title}

Price : ₹${price}

Description:

${product.body_html.replace(/<[^>]*>/g,'')}
`;

}




function handleAIMessage(message){

    console.log(
        "Original User Message:",
        message
    );


    //----------------------------------------
    // FUZZY MESSAGE UNDERSTANDING
    //----------------------------------------

    if(
        typeof fuzzyNormalizeMessage === "function"
    ){

        message =
            fuzzyNormalizeMessage(message);

    }


    console.log(
        "AI Understanding Message:",
        message
    );


    //----------------------------------------
    // PRIORITY PRODUCT FAMILY
    //----------------------------------------

    const requestedFamily =
        detectRequestedFamily(message);

    console.log(
        "Requested Family:",
        requestedFamily
    );


    //----------------------------------------
    // NON-INSTALLATION PRODUCTS
    //----------------------------------------

    const skipInstallation =
        typeof isNonInstallationProductRequest === "function"
            ? isNonInstallationProductRequest(
                message,
                requestedFamily
            )
            : false;


    //----------------------------------------
    // RESET CCTV CONSULTATION
    //----------------------------------------

    if(
        skipInstallation &&
        AI_STATE.active
    ){

        console.log(
            "Non-installation product detected."
        );

        console.log(
            "Stopping active CCTV consultation."
        );


        stopConversation();

    }


    //----------------------------------------
    // ACTIVE CONVERSATION
    //----------------------------------------

    if(AI_STATE.active){
        const next = saveConversationAnswer(message);


        //----------------------------------------
        // CONVERSATION FINISHED
        //----------------------------------------

        if(next === "FINISHED"){

            const answers = AI_STATE.answers;


            //----------------------------------------
            // BUILD SEARCH MESSAGE
            //----------------------------------------

            const searchMessage =

                "CCTV for " +

                answers.location +

                " " +

                (answers.wifi || "") +

                " " +

                (answers.budget || "");


            console.log(
                "Conversation Search Message:",
                searchMessage
            );


            //----------------------------------------
            // RECOMMEND PRODUCTS
            //----------------------------------------

            const products =
                recommendProductsByRequirement(
                    searchMessage
                );


            console.log(
                "Consultation Products:",
                products
            );


            //----------------------------------------
            // SMART ALTERNATIVES AFTER CONSULTATION
            //----------------------------------------

            if(
                products.length > 0 &&
                window.AI_ALTERNATIVE_DATA &&
                window.AI_ALTERNATIVE_DATA.active
            ){

                const alternativeData =
                    window.AI_ALTERNATIVE_DATA;


                //----------------------------------------
                // BUILD ALTERNATIVE RESPONSE
                //----------------------------------------

                const alternativeReply =
                    buildAlternativeResponse(
                        alternativeData.features,
                        alternativeData.budget,
                        alternativeData.products
                    );


                //----------------------------------------
                // SHOW AI EXPLANATION
                //----------------------------------------

                addBotMessage(
                    alternativeReply
                );


                //----------------------------------------
                // SHOW ALTERNATIVE PRODUCTS
                //----------------------------------------

                showProducts(
                    alternativeData.products.slice(0,5)
                );


                //----------------------------------------
                // UPDATE MEMORY
                //----------------------------------------

                AI_MEMORY.lastProducts =
                    alternativeData.products;

                AI_MEMORY.lastProduct =
                    alternativeData.products[0] || null;


                //----------------------------------------
                // CLEAR ALTERNATIVE STATE
                //----------------------------------------

                window.AI_ALTERNATIVE_DATA.active = false;


                //----------------------------------------
                // STOP CONSULTATION
                //----------------------------------------

                stopConversation();


                return true;

            }


            //----------------------------------------
            // NORMAL CONSULTATION RESULT
            //----------------------------------------

            addBotMessage(
                generateDecisionExplanation(answers)
            );


            //----------------------------------------
            // SHOW PRODUCTS
            //----------------------------------------

            showProducts(
                products.slice(0,5)
            );


            //----------------------------------------
            // STOP CONSULTATION
            //----------------------------------------

            stopConversation();


            return true;

        }


        //----------------------------------------
        // ASK NEXT QUESTION
        //----------------------------------------

        addBotMessage(

            next.question +

            "<br><br>" +

            next.options.join(" | ")

        );


        return true;

    }


    //----------------------------------------
    // DETECT INTENT
    //----------------------------------------

    const intent = detectIntent(message);


    //----------------------------------------
    // PRODUCT COMPARISON
    //----------------------------------------

    if(isComparisonRequest(message)){

        const categories =
            detectComparisonCategories(message);


        if(categories.length >= 2){

            const comparison =
                generateCategoryComparison(
                    categories
                );


            addBotMessage(
                comparison
            );


            return true;

        }


        addBotMessage(

            "Please mention two product categories to compare.<br><br>" +

            "Example:<br>" +

            "• Compare Bulb Camera and Outdoor Camera<br>" +

            "• PTZ Camera vs Bulb Camera"

        );


        return true;

    }


    //----------------------------------------
    // FOLLOW-UP QUESTIONS
    //----------------------------------------

    if(handleFollowUpQuestion(message)){

        return true;

    }


    //----------------------------------------
    // DETECT CATEGORY
    //----------------------------------------

    const category =
        detectRequestedCategory(message);


    //----------------------------------------
    // DETECT FAMILY
    //----------------------------------------

    const family =
        detectRequestedFamily(message);


    //----------------------------------------
    // START AI CONSULTATION
    //----------------------------------------

    /*
       Start the questionnaire ONLY when the
       customer has not already provided useful
       information such as location, features,
       or budget.
    */

   if(
    family === "CCTV" &&
    !getPrimaryRequirement(message) &&
    !isNonInstallationProductRequest(
        message,
        family
    )
){

        const knownAnswers =
            extractKnownAnswers(message);


        startConversation(
            "CCTV",
            knownAnswers
        );


        const question =
            getCurrentQuestion();


        addBotMessage(

            "<b>I'll help you choose the perfect CCTV camera.</b><br><br>" +

            question.question +

            "<br><br>" +

            question.options.join(" | ")

        );


        return true;

    }


    //----------------------------------------
    // AI RECOMMENDATION ENGINE
    //----------------------------------------

    const products =
        recommendProductsByRequirement(
            message
        );


    console.log(
        "AI Products:",
        products
    );


    //----------------------------------------
    // SMART ALTERNATIVE RECOMMENDATION
    //----------------------------------------

    if(

        products.length > 0 &&

        window.AI_ALTERNATIVE_DATA &&

        window.AI_ALTERNATIVE_DATA.active

    ){

        const alternativeData =
            window.AI_ALTERNATIVE_DATA;


        //----------------------------------------
        // BUILD ALTERNATIVE RESPONSE
        //----------------------------------------

        const alternativeReply =
            buildAlternativeResponse(

                alternativeData.features,

                alternativeData.budget,

                alternativeData.products

            );


        //----------------------------------------
        // SHOW EXPLANATION
        //----------------------------------------

        addBotMessage(
            alternativeReply
        );


        //----------------------------------------
        // SHOW PRODUCTS
        //----------------------------------------

        showProducts(

            alternativeData.products
                .slice(0,5)

        );


        //----------------------------------------
        // SAVE TO MEMORY
        //----------------------------------------

        AI_MEMORY.lastProducts =
            alternativeData.products;


        AI_MEMORY.lastProduct =
            alternativeData.products[0] || null;


        //----------------------------------------
        // CLEAR ALTERNATIVE STATE
        //----------------------------------------

        window.AI_ALTERNATIVE_DATA.active =
            false;


        return true;

    }


    //----------------------------------------
    // CUSTOMER REQUIREMENT
    //----------------------------------------

    const requirement =
        getPrimaryRequirement(message);


    if(requirement){

        const reasoning =
            getRecommendationReason(
                requirement
            );


        if(reasoning){

            let reply = "";


            reply +=
                "🏠 <b>Recommendation Based On Your Requirement</b><br><br>";


            reply +=
                reasoning.reason +
                "<br><br>";


            reply +=
                "<b>Recommended Product Types</b><br>";


            reasoning.recommend.forEach(item=>{

                reply +=
                    "• " +
                    item +
                    "<br>";

            });


            addBotMessage(
                reply
            );

        }

    }


    //----------------------------------------
    // FIRST PRODUCT
    //----------------------------------------

    const product =
        products.length
            ? products[0]
            : null;


    console.log(
        "Intent:",
        intent
    );


    console.log(
        "Products Found:",
        products.length
    );


    //----------------------------------------
    // SAVE CONVERSATION MEMORY
    //----------------------------------------

    AI_MEMORY.lastIntent =
        intent;


    AI_MEMORY.lastProducts =
        products;


    AI_MEMORY.lastProduct =
        product;


    AI_MEMORY.lastRequirement =
        detectRequirement(message);


    //----------------------------------------
    // DETECT CATEGORY FOR MEMORY
    //----------------------------------------

    AI_MEMORY.lastCategory =
        null;


    for(
        const phrase in PRODUCT_PHRASES
    ){

        if(
            message
                .toLowerCase()
                .includes(phrase)
        ){

            AI_MEMORY.lastCategory =
                phrase;


            break;

        }

    }


    console.log(
        "Conversation Memory:",
        AI_MEMORY
    );


    //----------------------------------------
    // CATEGORY KNOWLEDGE + MULTIPLE PRODUCTS
    //----------------------------------------

    if(products.length > 1){

        let category =
            null;


        //----------------------------------------
        // FIND CATEGORY
        //----------------------------------------

        for(
            const phrase in PRODUCT_PHRASES
        ){

            if(
                message
                    .toLowerCase()
                    .includes(phrase)
            ){

                category =
                    phrase;


                break;

            }

        }


        //----------------------------------------
        // CATEGORY INFORMATION
        //----------------------------------------

        if(category){

            const info =
                getCategoryKnowledge(
                    category
                );


            if(info){

                let reply = "";


                reply +=
                    "📦 <b>" +
                    category.toUpperCase() +
                    "</b><br><br>";


                reply +=
                    "🤖 <b>AI Summary</b><br>";


                reply +=
                    info.summary +
                    "<br><br>";


                reply +=
                    "⭐ <b>Common Features</b><br>";


                info.features.forEach(feature=>{

                    reply +=
                        "• " +
                        feature +
                        "<br>";

                });


                reply +=
                    "<br>";


                reply +=
                    "🏠 <b>Best For</b><br>";


                info.bestFor.forEach(item=>{

                    reply +=
                        "• " +
                        item +
                        "<br>";

                });


                reply +=
                    "<br>";


                reply +=
                    "🛒 <b>Available Models (" +
                    products.length +
                    ")</b>";


                addBotMessage(
                    reply
                );

            }

        }

        else{

            addBotMessage(

                "I found " +
                products.length +
                " matching products."

            );

        }


        //----------------------------------------
        // SHOW PRODUCTS
        //----------------------------------------

        console.log(
            "Showing Products:",
            products
                .slice(0,5)
                .map(item => item)
        );


        showProducts(

            products
                .slice(0,5)
                .map(item => item)

        );


        return true;

    }


    //----------------------------------------
    // DETAILS / FEATURES / WARRANTY
    //----------------------------------------

    if(

        intent === AI_INTENTS.DETAILS ||

        intent === AI_INTENTS.FEATURES ||

        intent === AI_INTENTS.WARRANTY

    ){

        if(product){

            const knowledge =
                getProductKnowledge(
                    product
                );


            let reply = "";


            //----------------------------------------
            // PRODUCT TITLE
            //----------------------------------------

            reply +=
                "📦 <b>" +
                product.title +
                "</b><br><br>";


            //----------------------------------------
            // AI SUMMARY
            //----------------------------------------

            if(knowledge.aiSummary){

                reply +=
                    "🤖 <b>AI Summary</b><br>";


                reply +=
                    knowledge.aiSummary +
                    "<br><br>";

            }


            //----------------------------------------
            // FEATURES
            //----------------------------------------

            if(
                knowledge.features.length
            ){

                reply +=
                    "⭐ <b>Features</b><br>";


                knowledge.features.forEach(feature=>{

                    reply +=
                        "• " +
                        feature +
                        "<br>";

                });


                reply +=
                    "<br>";

            }


            //----------------------------------------
            // BEST FOR
            //----------------------------------------

            if(
                knowledge.bestFor.length
            ){

                reply +=
                    "🏠 <b>Best For</b><br>";


                knowledge.bestFor.forEach(item=>{

                    reply +=
                        "• " +
                        item +
                        "<br>";

                });


                reply +=
                    "<br>";

            }


            //----------------------------------------
            // INSTALLATION
            //----------------------------------------

            if(
                knowledge.installation
            ){

                reply +=
                    "🔧 <b>Installation</b><br>";


                reply +=
                    knowledge.installation +
                    "<br><br>";

            }


            //----------------------------------------
            // WARRANTY
            //----------------------------------------

            reply +=
                "🛡 <b>Warranty:</b> " +
                knowledge.warranty +
                "<br><br>";


            //----------------------------------------
            // PRICE
            //----------------------------------------

            reply +=
                "💰 <b>Price:</b> ₹" +
                product.variants[0].price;


            //----------------------------------------
            // SEND RESPONSE
            //----------------------------------------

            addBotMessage(
                reply
            );


            //----------------------------------------
            // SHOW PRODUCT
            //----------------------------------------

            showProducts(
                [product]
            );


            return true;

        }

    }


    //----------------------------------------
    // NOTHING HANDLED
    //----------------------------------------

    return false;

}